// extracted by mini-css-extract-plugin
export default {"portfolio-container":"portfolio_portfolio-container__IWBpE"};